// extracted by mini-css-extract-plugin
export var active = "_tf-1";
export var circle = "_tf-0";
export var completed = "_tf-2";
export var connector = "_tf-4";
export var connectorCompleted = "_tf-7";
export var connectorSpacer = "_tf-5";
export var iconStrokeOverride = "_tf-8";
export var labelContainer = "_tf-6";
export var pending = "_tf-3";